import React from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import TravelCreditDetail from './TravelCreditDetail';

const SingleTravelCredit = ({
  selectedAccountData,
  hasTravelCreditCenturionCardArt,
}) => {
  const { formatMessage } = useIntl();
  const { travelCredit } = selectedAccountData;
  return (
    <div>
      <h3 className="heading-1 margin-b hidden-sm-down">
        {formatMessage({ id: 'travelCreditTab.heading' })}
      </h3>
      <TravelCreditDetail
        selectedAccountData={selectedAccountData}
        selectedTravelCredit={travelCredit[0]}
        hasTravelCreditCenturionCardArt={hasTravelCreditCenturionCardArt}
      />
    </div>
  );
};

SingleTravelCredit.propTypes = {
  selectedAccountData: PropTypes.shape({
    displayAccountNumber: PropTypes.string,
    cardArtCdnLink: PropTypes.string,
    travelCredit: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string,
      marketingText: PropTypes.string,
      callToActionText: PropTypes.string,
      landingPage: PropTypes.string,
      expiry: PropTypes.string,
    })),
  }),
  hasTravelCreditCenturionCardArt: PropTypes.bool.isRequired,
};

export default SingleTravelCredit;
